import { create } from 'zustand';

import { IClinic } from '../hooks/useClinics';
import i18n from '../i18n';
import { getDefaultRadiusUnit, RadiusUnit } from '../utils/helpers';

type TSortClinicsBy = 'experience' | 'distance';
type TListType = 'list' | 'map';

// Define the store's state and actions
export type TLocatorStore = {
  activeClinic: IClinic | undefined;
  setActiveClinic: (clinic: IClinic) => void;
  radius: number;
  setRadius: (radius: number | undefined) => void;
  radiusUnit: RadiusUnit;
  setRadiusUnit: (radiusUnit: RadiusUnit) => void;
  searchInput: string;
  setSearchInput: (searchInput: string) => void;
  currentLocation: google.maps.LatLngLiteral | undefined;
  setCurrentLocation: (currentLocation: google.maps.LatLngLiteral | undefined) => void;
  sortClinicsBy: TSortClinicsBy;
  setSortClinicsBy: (sortClinicsBy: TSortClinicsBy) => void;
  visibleClinics: IClinic[];
  setVisibleClinics: (visibleClinics: IClinic[]) => void;
  radiusOffsetInMetres: number;
  setRadiusOffsetInMetres: (radiusOffsetInMetres: number) => void;
  closestClinic: IClinic | undefined;
  setClosestClinic: (closestClinic: IClinic | undefined) => void;
  listType: TListType;
  setListType: (listType: TListType) => void;
  sidebarOpen: boolean;
  setSidebarOpen: (sidebarOpen: boolean) => void;
  shouldGeoLocate: boolean;
  setShouldGeoLocate: (shouldGeoLocate: boolean) => void;
  mapViewBounds: google.maps.LatLngBounds | undefined;
  setMapViewBounds: (mapViewBounds: google.maps.LatLngBounds) => void;
  isUserZooming: boolean;
  setIsUserZooming: (isUserZooming: boolean) => void;
};

// Create the store without the devtools middleware
export const useLocatorStore = create<TLocatorStore>()((set) => ({
  activeClinic: undefined,
  setActiveClinic: (clinic) => {
    set({ activeClinic: clinic });
  },
  radius: 10,
  setRadius: (radius) => {
    set({ radius });
  },
  radiusUnit: getDefaultRadiusUnit(i18n.language),
  setRadiusUnit: (radiusUnit) => {
    set({ radiusUnit });
  },
  searchInput: '',
  setSearchInput: (searchInput) => {
    set({ searchInput });
  },
  currentLocation: undefined,
  setCurrentLocation: (currentLocation) => {
    set({ currentLocation });
  },

  sortClinicsBy: 'experience',
  setSortClinicsBy: (sortClinicsBy) => {
    set({ sortClinicsBy });
  },
  visibleClinics: [],
  setVisibleClinics: (visibleClinics) => {
    set({ visibleClinics });
  },
  radiusOffsetInMetres: 0,
  setRadiusOffsetInMetres: (radiusOffsetInMetres) => {
    set({ radiusOffsetInMetres });
  },
  closestClinic: undefined,
  setClosestClinic: (closestClinic) => {
    set({ closestClinic });
  },
  listType: 'map',
  setListType: (listType) => {
    set({ listType });
  },
  sidebarOpen: true,
  setSidebarOpen: (sidebarOpen) => {
    set({ sidebarOpen });
  },
  shouldGeoLocate: false,
  setShouldGeoLocate: (shouldGeoLocate) => {
    set({ shouldGeoLocate });
  },
  mapViewBounds: undefined,
  setMapViewBounds: (mapViewBounds) => {
    set({ mapViewBounds });
  },
  isUserZooming: true,
  setIsUserZooming: (isUserZooming) => {
    set({ isUserZooming });
  },
}));
